import { Icon } from "semantic-ui-react";

import styles from "./externalLinksNoResults.module.scss";
import NoResultsWithButton from "components/noResultsWithButton/NoResultsWithButton";

export interface Props {
  filtered?: boolean;
  title?: string;
  description?: string;
  createButton?: React.ReactElement;
}

export const ExternalLinksNoResults = (props: Props) => {
  return (
    <NoResultsWithButton
      title={props.title || "You don't have any links"}
      description={props.description || "Looks like you don't have any links yet."}
      actionText={props.createButton ? "Create one now using the button below." : undefined}
      icon={<Icon className={`fa-link ${styles.icon}`} />}
      actionButton={props.createButton}
      filtered={props.filtered}
    />
  );
};
